module.exports = __webpack_public_path__ + "media/images/suceess-story3-ee13f8946373a09a77451c5354aef6b2.jpg";